var touch_useful_x = -1,
	touch_useful_y = -1,
	touch_useful_t = -1,
	touch_useful_tm = null;

function touch_useful_end() {
	touch_useful_x = -1;
	touch_useful_y = -1;
	touch_useful_t = -1;
	$('.useful__tabs .item_act').css({left: ''}).parent().addClass('anim');
}

$(document).ready(function () {

	$('.useful__nav-button').on('click', function () {

		let index = $('.useful__nav-button').index(this) + 1;

		if ($(this).hasClass('useful__nav-button_active')) {
			if ($('.useful__nav-button').length >= index) index++;
			else index = 1;
		}

		nextSlide(index, 'useful');

	});

	$('.useful_button').on('click', function (event) {
		useful_escape(event);
		let obj = $(this).attr('aria-expanded', true).next().addClass('useful_popup--active').focus();
		setTimeout(() => {
			obj.addClass('useful_popup--height_auto')
		}, 400);
		event.stopPropagation();
		window.addEventListener('keydown', useful_escape);
		window.addEventListener('click', useful_escape);
	});

	$('.useful__tab').on('transitionend', function () {
		$(this).addClass('ani_end');
	});

	$('.useful_line').on('transitionend', function () {
		$(this).parent().addClass('ani_height');
	});
	$('.useful__tab-content').on('transitionend', function () {
		$(this).addClass('ani_height_end');
	});

	$('.useful__tabs').on('mousedown touchstart', function (e) {
		if ($(window).width() > 900) return;
		if (touch_useful_tm) window.clearTimeout(touch_useful_tm);
		touch_useful_tm = setTimeout(touch_useful_end, 1000);
		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		touch_useful_x = touch.pageX;
		touch_useful_y = touch.pageY;
		touch_useful_t = 0;
	}).on('mousemove touchmove', function (e) {
		if (touch_useful_t == 1 || touch_useful_x == -1) return; // top-botom
		if (touch_useful_t == 2) e.preventDefault(); // left-right
		if (touch_useful_t == -1) return; // for mouse
		var touch = e;
		if (e.type == 'touchmove') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		this_x = touch.pageX;
		this_y = touch.pageY;
		if (touch_useful_t == 0) {
			if (Math.abs(this_x - touch_useful_x) > Math.abs(this_y - touch_useful_y) + 2) {
				touch_useful_t = 2;
				e.preventDefault();
			} else if (Math.abs(this_x - touch_useful_x) + 2 < Math.abs(this_y - touch_useful_y)) {
				touch_useful_t = 1;
				return;
			} else {
				return;
			}
		}
		if (touch_useful_tm) window.clearTimeout(touch_useful_tm);
		touch_useful_tm = setTimeout(touch_useful_end, 1000);
		if (this_x - touch_useful_x > 50) {
			$('.useful__tabs .item_act').css({left: ''});
			let index = $('.useful__nav-button').index($('.useful__nav-button_active')[0]);
			if (!index) index = $('.useful__nav-button').length;
			nextSlide(index, 'useful');
			touch_useful_end();
			return;
		}
		if (this_x - touch_useful_x < -50) {
			$('.useful__tabs .item_act').css({left: ''});
			let index = $('.useful__nav-button').index($('.useful__nav-button_active')[0]) + 2;
			if ($('.useful__nav-button').length < index) index = 1;
			nextSlide(index, 'useful');
			touch_useful_end();
			return;
		}
		$('.useful__tabs .item_act').css({left: 30 + this_x - touch_useful_x});
	}).on('mouseup', touch_useful_end);

});

function nextSlide(index, block) {

	let prev_act = $('.' + block + '__nav-button_active'),
		activeButton = $('.' + block + '__nav-button:nth-of-type(' + index + ')');

	$('.' + block + '__nav').prepend(`<div class="${block}__nav-animate-rec" 
                                   style="left: ${prev_act.position().left}px;
                                         width: ${prev_act.outerWidth()}px;
                                         color: ${prev_act.css('borderColor')};">
                               </div>`);

	$('.' + block + '__nav-animate-rec').css('color');

	$('.' + block + '__tab.item_act').removeClass('item_act');

	let left = 0, width = 0;

	if (prev_act.position().left > activeButton.position().left) {
		left = activeButton.position().left;
		width = prev_act.position().left - activeButton.position().left + prev_act.outerWidth();
	} else {
		left = prev_act.position().left;
		width = activeButton.position().left - prev_act.position().left + activeButton.outerWidth();
	}

	$('.' + block + '__nav-animate-rec').css({
		'left': left,
		'width': width + parseFloat(prev_act.css('borderWidth')) * 2,
		'color': '#ccc'
	});

	$('.' + block + '__nav-animate-rec').on('transitionend', function () {
		$('.' + block + '__nav-animate-rec').remove();
		$('.' + block + '__nav-button_active').removeClass(block + '__nav-button_active');
		activeButton.addClass(block + '__nav-button_active');
	});

	let active = $('.' + block + '__tab:nth-of-type(' + index + ')').removeClass('item_r item_l').addClass('item_act');

	active.prevAll('.' + block + '__tab').removeClass('item_r').addClass('item_l');
	active.nextAll('.' + block + '__tab').removeClass('item_l').addClass('item_r');

}

function useful_escape(event) {

	if (event.which == 27 || $(event.target).hasClass('useful_popup__close') || (event.type != 'keydown' && (event.target.closest('.useful_popup__close') || !event.target.closest('.useful_popup--active')))) {

		if (event.target.closest('.useful_popup__close')) event.target.closest('.useful_popup__close').blur();
		if ($('.useful_popup--active').length) {
			$('.useful_popup--active').removeClass('useful_popup--active useful_popup--height_auto').addClass('useful_popup--closing').prev().attr('aria-expanded', false);
			setTimeout(() => {
				$('.useful_popup--closing').removeClass('useful_popup--closing').blur();
				if (event.type == 'keydown' && event.which != 9) {
					$(event.target.closest('li')).find('.useful_button').focus();
				}
			}, 500);
		}

		window.removeEventListener('keydown', useful_escape);
		window.removeEventListener('click', useful_escape);

	}

}